<template>

        <the-mask
                  mask="+7 ###-###-####"
                  type="tel" placeholder="Телефон"
                  :value="value"
                  v-model="phone"
                  v-on:input="input($event)"
                  >
        </the-mask>

</template>

<script>
import { TheMask } from "vue-the-mask";

export default {
    name: "SmartPhoneField",
    components: {TheMask},
    data: function (){
      return {
          phone: this.value
      }
    },
    props: {
        value: {
            type: String,
            required: true
        }
    },
    methods: {
        input (e){

            if (this.phone.length > 1){
                if (this.phone[0]==='8'){
                    this.phone = this.phone.substring(1);
                }
            }
            this.$emit('input', e);
        }
    }

}
</script>

<style scoped>

</style>
